<mat-card *ngIf="lesson() as lesson; else loading">
  <mat-card-header>
    <mat-card-title>
      {{lesson.title | capitalize}}
    </mat-card-title>
    <a mat-button [routerLink]="['/courses/' + lesson.course.id + '/lessons/' + lesson.id + '/edit']" color="primary">
      Edit
    </a>
  </mat-card-header>
  <mat-card-content>
    <mat-card>
      <mat-card-subtitle class="student">Description</mat-card-subtitle>
      <p>{{lesson.description}}</p>

      <mat-card-subtitle class="student">Lesson Settings</mat-card-subtitle>
      <p><mat-checkbox [disabled]="true" [checked]="!!lesson.strategyLessonEnabled" matInput>Strategy Lesson</mat-checkbox></p>
      <p><mat-checkbox [disabled]="true" [checked]="!!lesson.smartSaversEnabled" matInput>Show Smartsavers</mat-checkbox></p>
      <p><mat-checkbox [disabled]="true" [checked]="!!lesson.showCorrectEnabled" matInput>Show Correct Answers</mat-checkbox></p>
      <p><mat-checkbox [disabled]="true" [checked]="!!lesson.showMetricsEnabled" matInput>Show Metrics</mat-checkbox></p>
      <p><mat-checkbox [disabled]="true" [checked]="!!lesson.openAnswerOnComplete" matInput>Open Answer on Complete</mat-checkbox></p>

    </mat-card>

    <mat-card>
      <mat-card-header>
        <mat-card-title>
          Exercises
        </mat-card-title>
        <a mat-button [routerLink]="['/courses/' + lesson.course.id + '/lessons/' + lesson.id + '/exercises/create']"
           color="primary">
          Add Exercise
        </a>
      </mat-card-header>

      <mat-card-content>
        <mat-expansion-panel *ngFor="let exercise of lesson.exercises" [expanded]="false">
          <mat-expansion-panel-header>
            <mat-panel-title>{{exercise.title}}</mat-panel-title>
            <button mat-button color="primary"
                    [routerLink]="['/courses/'+ lesson.course.id +'/lessons/' +lesson.id + '/exercises/' + exercise.id + '/manage']">
              Manage
            </button>
            <button mat-button color="primary"
                    [routerLink]="['/courses/'+ lesson.course.id +'/lessons/' +lesson.id + '/exercises/' + exercise.id + '/edit']">
              Edit
            </button>
          </mat-expansion-panel-header>

          <mat-card-subtitle>Subject</mat-card-subtitle>
          <p>{{exercise.subject}}</p>
          <mat-card-subtitle class="student">Description</mat-card-subtitle>
          <p>{{exercise.description}}</p>
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>
  </mat-card-content>
</mat-card>

<ng-template #loading>
  <app-spinner></app-spinner>
</ng-template>
